import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageToggle from './LanguageToggle';

export type Perspective = 'officer' | 'applicant';

interface Props {
  onSelect: (perspective: Perspective) => void;
}

const PerspectiveSelect: React.FC<Props> = ({ onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="perspective-screen">
      <div className="perspective-lang-toggle"><LanguageToggle /></div>
      <div className="perspective-header">
        <div className="perspective-logo">⚖️</div>
        <h1 className="perspective-title">BorderJudge</h1>
        <p className="perspective-subtitle">{t('perspective.subtitle')}</p>
      </div>

      <div className="perspective-cards">
        <button className="perspective-card available" onClick={() => onSelect('officer')}>
          <div className="perspective-card-icon">🛂</div>
          <div className="perspective-card-name">{t('perspective.officer.name')}</div>
          <div className="perspective-card-desc">{t('perspective.officer.desc')}</div>
          <div className="perspective-card-tag available-tag">{t('perspective.available')}</div>
        </button>

        <button className="perspective-card disabled" disabled>
          <div className="perspective-card-icon">🧳</div>
          <div className="perspective-card-name">{t('perspective.applicant.name')}</div>
          <div className="perspective-card-desc">{t('perspective.applicant.desc')}</div>
          <div className="perspective-card-tag coming-soon-tag">{t('perspective.comingSoon')}</div>
        </button>
      </div>

      <p className="perspective-hint">{t('perspective.hint')}</p>
    </div>
  );
};

export default PerspectiveSelect;
